import React, { forwardRef } from "react";

interface InputCheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string | JSX.Element;
  showContainer?: boolean;
}

const InputCheckbox = forwardRef<HTMLInputElement, InputCheckboxProps>(
  ({ label, showContainer = true, ...props }, ref) => {
    return showContainer ? (
      <div className="tw-flex tw-items-center tw-gap-x-2">
        <input
          ref={ref}
          type="checkbox"
          {...props}
          className={"tw-accent-v_blue-dark"}
        />
        {label ? (
          <label className="tw-font-montserrat" htmlFor={props.id}>
            {label}
          </label>
        ) : (
          <></>
        )}
      </div>
    ) : (
      <>
        <input
          ref={ref}
          type="checkbox"
          {...props}
          className={"tw-accent-v_blue-dark"}
        />
        {label ? (
          <label className="tw-font-montserrat" htmlFor={props.id}>
            {label}
          </label>
        ) : (
          <></>
        )}
      </>
    );
  }
);

export default InputCheckbox;
